import { render, staticRenderFns } from "./VFilePreview.vue?vue&type=template&id=53cb5a31&scoped=true"
import script from "./VFilePreview.vue?vue&type=script&lang=js"
export * from "./VFilePreview.vue?vue&type=script&lang=js"
import style0 from "./VFilePreview.vue?vue&type=style&index=0&id=53cb5a31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cb5a31",
  null
  
)

export default component.exports